import { ErrorMessageComponent } from "@/features/api/domain/ErrorMessageComponent";
import { Text } from "@meditect/medibase-components";

export interface PrivateProductLabelAlreadyExistOnAnotherPharmacyProductErrorExtra {
  pharmacyProductId: string;
}

export const PrivateProductLabelAlreadyExistOnAnotherPharmacyProductError: ErrorMessageComponent<
  PrivateProductLabelAlreadyExistOnAnotherPharmacyProductErrorExtra
> = () => {
  return (
    <Text as="span" mr={1}>
      Ce label de produit existe déjà dans votre pharmacie, veuillez choisir le produit de votre pharmacie plutôt que de
      créer un nouveau produit.
    </Text>
  );
};
